import { render } from "./RouterButton.vue?vue&type=template&id=161d12d6&scoped=true"
import script from "./RouterButton.vue?vue&type=script&lang=js"
export * from "./RouterButton.vue?vue&type=script&lang=js"

import "./RouterButton.vue?vue&type=style&index=0&id=161d12d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161d12d6"]])

export default __exports__